import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';

function Officials() {
    const { id: cogen_id, plantName } = useParams(); // 👈 Get cogen_id from route
    const [officials, setOfficials] = useState([]);

    useEffect(() => {
        const fetchOfficials = async () => {
            try {
                const res = await axios.get(`https://backend-zkgn.onrender.com/api/cogen_officials/${cogen_id}`);
                setOfficials(res.data); // API should return array of officials
            } catch (error) {
                console.error('Error fetching officials:', error.message);
            }
        };

        fetchOfficials();
    }, [cogen_id]);

    const handleDelete = async (official_id) => {
        if (window.confirm("Are you sure you want to delete this official?")) {
            try {
                await axios.delete(`https://backend-zkgn.onrender.com/api/cogen_officials/${official_id}`);
                setOfficials(prev => prev.filter(off => off.official_id !== official_id));
            } catch (err) {
                console.error("Delete failed:", err.message);
            }
        }
    };

    return (
        <div className="container-fluid my-5">
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                <h4 className="fw-bold text-tertiary mb-2">{officials.length} - Officials Found</h4>
                <Link to={`/add-official/${plantName}/${cogen_id}`} className="btn btn-primary">
                    Add Plant Official
                </Link>
            </div>

            <div className="table-responsive">
                <table className="table table-bordered officials-table">
                    <thead className="table-light">
                        <tr>
                            <th>Designation</th>
                            <th>Official's Name</th>
                            <th>Official's Email</th>
                            <th>Mobile Number</th>
                            <th>Phone Number</th>
                            <th className="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {officials.map((official) => (
                            <tr key={official.official_id}>
                                <td>{official.designation}</td>
                                <td>{official.officials_name}</td>
                                <td>{official.officials_email}</td>
                                <td>{official.mobile_no}</td>
                                <td>{official.phone_number}</td>
                                <td className="text-center">
                                    <Link
                                        to={`/edit-official/${plantName}/${official.official_id}/${cogen_id}`}
                                        className="btn btn-link text-success me-2 p-0"
                                    >
                                        <i className="fa fa-edit"></i>
                                    </Link>
                                    <button
                                        className="btn btn-link text-danger p-0"
                                        onClick={() => handleDelete(official.official_id)}
                                    >
                                        <i className="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Officials;
